import styled from 'styled-components';
import { IonButton } from '@ionic/react';

export const Root = styled(IonButton)`
  font-weight: 500 !important;
`;
